// extracted by css-extract-rspack-plugin
var _1 = "ot";
var _2 = "ou";
var _3 = "os";
var _4 = "oq";
var _5 = "or";
var _6 = "op";
var _7 = "f3";
var _8 = "n1";
export { _1 as "alignBottom", _2 as "alignLeft", _3 as "alignRight", _4 as "alignTop", _5 as "alignTopLeft", _6 as "fadeIn", _7 as "icon", _8 as "iconWithBalloonComponent" }
